import React, { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Modal from 'react-responsive-modal'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { createCulture, updateCulture } from '../../actions/culture'
import { Input } from '../../components/ModalInputs'
import Button from '../../components/Button'
import Confirmation from '../../components/Confirmation/Confirmation'
import { createNotification } from '../../components/Notifications/Notifications'
import styles from './styles.module.scss'

const INITIAL_VALUES = { name: '' }

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required('Заполните название')
    .max(255, 'Должно быть не более 255 символов'),
})

export default function CultureModal({ open, onClose, data, addMode, list }) {
  const dispatch = useDispatch()
  const [confirmation, setConfirmation] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const submit = async (values) => {
    const name = values.name.trim()
    const isDuplicate = list.some(item =>
      item.name?.toLowerCase() === name.toLowerCase() && item.id !== data?.id
    )
    if (isDuplicate) {
      createNotification('error', 'Запись с таким названием уже существует')
      return
    }
    setIsSubmitting(true)
    try {
      if (addMode) {
        await dispatch(createCulture({ name }, onClose))
      } else {
        await dispatch(updateCulture({ ...data, name }, onClose))
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const {
    values,
    errors,
    touched,
    dirty,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: data?.id ? data : INITIAL_VALUES,
    validationSchema,
    onSubmit: submit
  })

  const handleCloseModal = useCallback(() => {
    if (dirty) {
      setConfirmation(true)
    } else {
      onClose()
    }
  }, [dirty, onClose])

  const acceptConfirmation = useCallback(() => {
    onClose()
    setConfirmation(false)
  }, [onClose])

  const rejectConfirmation = useCallback(() => {
    setConfirmation(false)
  }, [])

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      classNames={{ modal: styles.modal }}
      closeOnEsc={!dirty}
      closeOnOverlayClick={!dirty}
      showCloseIcon={false}
      animationDuration={200}
      center
    >
      <form onSubmit={handleSubmit} className={styles.modalForm}>
        <div className={styles.modalMain}>
          <h2>{addMode ? 'Добавление записи' : 'Изменение записи'}</h2>

          <Input
            name="name"
            label="Название"
            required
            maxLength={255}
            placeholder="Введите название записи"
            value={values.name || ''}
            error={touched.name && errors.name}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={isSubmitting}
            autoFocus
          />
        </div>

        <div className={styles.modalFooter}>
          <Button
            mode="white"
            type="submit"
            loading={isSubmitting}
            disabled={isSubmitting || !dirty}
          >
            Сохранить
          </Button>
          <Button
            mode="bordered"
            type="button"
            onClick={handleCloseModal}
            disabled={isSubmitting}
          >
            Отмена
          </Button>
        </div>
      </form>

      {confirmation && (
        <Confirmation
          title="Есть несохраненные данные. Уверены, что хотите выйти?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
